import React from 'react';
import AutoCompleteText from './AutoCompleteText';


export default class herstuff extends React.Component {
    constructor (props) {
        super(props);
    }
    dostuff() {
        const datastuff = [
            "Vitamin and mineral supplements cannot cure COVID-19",
            "Studies show hydroxychloroquine does not have clinical benefits in treating COVID-19",
            "People should NOT wear masks while exercising",
            "The likelihood of shoes spreading COVID-19 is very low",
            "The coronavirus disease (COVID-19) is caused by a virus, NOT by bacteria",
            "The prolonged use of medical masks* when properly worn, DOES NOT cause CO2 intoxication nor oxygen deficiency",
            "Most people who get COVID-19 recover from it",
            "Drinking alcohol does not protect you against COVID-19 and can be dangerous",
            "Thermal scanners CANNOT detect COVID-19",
            "There are currently no drugs licensed for the treatment or prevention of COVID-19",
            "Adding pepper to your soup or other meals DOES NOT prevent or cure COVID-19",
            "COVID-19 is NOT transmitted through houseflies",
            "Spraying and introducing bleach or another disinfectant into your body WILL NOT protect you against COVID-19 and can be dangerous",
            "Drinking methanol, ethanol or bleach DOES NOT prevent or cure COVID-19 and can be extremely dangerous",
            "5G mobile networks DO NOT spread COVID-19",
            "Exposing yourself to the sun or temperatures higher than 25°C DOES NOT protect you from COVID-19",
            "Catching COVID-19 DOES NOT mean you will have it for life",
            "Being able to hold your breath for 10 seconds or more without coughing or feeling discomfort DOES NOT mean you are free from COVID-19",
            "The COVID-19 virus can spread in hot and humid climates",
            "Cold weather and snow CANNOT kill the COVID-19 virus",
            "Taking a hot bath does not prevent COVID-19The COVID-19 virus CANNOT be spread through mosquito bites",
            "Hand dryers are NOT effective in killing the COVID-19 virus",
            "Ultra-violet (UV) lamps should NOT be used to disinfect hands or other areas of your skin",
            "Vaccines against pneumonia DO NOT protect against the COVID-19 virus",
            "Rinsing your nose with saline does NOT prevent COVID-19 ",
            "eating garlic does NOT prevent COVID-19",
            "People of all ages can be infected by the COVID-19 virus",
            "Antibiotics CANNOT prevent or treat COVID-19",
            "There are no medicines that can prevent or treat COVID-19"
        ];

        /*
        const request = require('request');
        const cheerio = require('cheerio');

        request('https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters', (error, response, html) => {
        if (!error && response.statusCode === 200) {
            const $ = cheerio.load(html);

            const row = $('.row');
            //console.log(row.text());

            const output = row.find('h2').text().replace(/\s\s+/g, '');
            console.log(output);
            var word = "";
        var userwant = AutoCompleteText.userenter.text;
        var found = false;
        var i;
        for (i=0; i <output.length-3; i++){
            if (output.slice(i,i+3)==="FACT"){
                word = "";
                i+=5;
                while (output.slice(i,i+3)!=="FACT"){
                    word+=output[i];
                    i++;
                }
                var match = word.match(userwant);
                if (match!=null){
                    found = true;
                    console.log("The world health organisation states"+word)
                    return "The world health organisation states"+word;
                    i = output.length-3;
                }
            }
        }
        if (!found){
            console.log("The world health organisation has not said anything about this yet.")
            return "The world health organisation has not said anything about this yet.";
        }

            
        }    
        });
        
        */
       var i= 0;
       var userwant = AutoCompleteText.userenter.text;
       var found = false;
        for (i = 0 ; i <datastuff.length;i++){
            if (datastuff[i].match(userwant) != null){
                found = true;
                
                return datastuff[i];
            }
        }
        return "the WHO has not commented on this matter";
    }

    render () {

        return (
            <div>
                <p> {this.dostuff()} </p>
            </div>
        );
    }
}